import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Box, CircularProgress } from '@mui/material';

export const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <Box sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh'
      }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ message: 'Accesso negato. Effettua il login per continuare.' }} />;
  }

  if (adminOnly && !user.isAdmin) {
    return <Navigate to="/dashboard" state={{ message: 'Accesso riservato agli amministratori.' }} />;
  }

  return children;
};